import gql from 'graphql-tag';

// TODO: parametr id přejmenovat na id_smlouvy !!!
export const CreateContractClient2Mutation = gql`
  mutation createContractClient2($id: ID!, $data: CreateContractClient2Input!) {
    createContractClient2(id: $id, data: $data) {
      id
      client2 {
        id
      }
    }
  }
`;
